import { initFederation } from '@angular-architects/native-federation';
// import { Buffer } from 'buffer';

// if (!('Buffer' in globalThis)) {
//   (globalThis as { Buffer?: typeof Buffer }).Buffer = Buffer;
// }

initFederation()
  .catch(err => console.error(err))
  .then(_ => import('./bootstrap'))
  .catch(err => console.error(err));
